import React, { createContext, useContext } from "react";

import PhotoUploadDropzoneGrid from "./PhotoUploadDropzoneGrid";

import { usePhotoUpload } from "frontend/hooks/usePhotoUpload";
import { useDropzone } from "core/Dropzone/hooks/useDropzone";

import {
    useBatchQueueStatus,
    usePhotoUploadsInDropzone,
    useUploadsCurrentlyProcessing
} from "../PhotoUploadCore/hooks";

export const PhotoUploadDropzoneContext = createContext();

export const PhotoUploadDropzoneProvider = ({ children }) => {
    const { uploadCount } = usePhotoUploadsInDropzone();
    const { addToCurrentlyProcessing } = useUploadsCurrentlyProcessing();

    const startProcessing = files => {
        const filenames = files.map(file => file.name);
        addToCurrentlyProcessing(filenames);
    };

    const { uploadPhotos } = usePhotoUpload();
    const { photoSubmissionBalance } = useBatchQueueStatus();

    const dropzoneProps = useDropzone({
        uploadFiles: uploadPhotos,
        onDropAccepted: startProcessing,
        addedFilesComponent: <PhotoUploadDropzoneGrid />,
        filesInDropzoneCount: uploadCount,
        initialMaximumFiles: photoSubmissionBalance
    });

    const contextValues = {
        dropzoneProps
    };

    return (
        <PhotoUploadDropzoneContext.Provider value={contextValues}>
            {children}
        </PhotoUploadDropzoneContext.Provider>
    );
};

export const usePhotoUploadDropzone = () => {
    const context = useContext(PhotoUploadDropzoneContext);

    if (context === undefined) {
        throw new Error(
            "usePhotoUploadDropzone must be used within a PhotoUploadDropzoneProvider"
        );
    }

    return context;
};

export default usePhotoUploadDropzone;
